import React from 'react';
import { Link } from 'react-router-dom';

function NavBar() {
  return (
    <header className="main-header px-3">
      <a href="/" className="brand-logo">
        <img src="/images/logo.png" alt="company logo" />
        <div className="brand-logo-name text-white">DevCenter</div>
      </a>
      <nav className="main-nav">
        <ul>
          <li>
            <Link to="/about">
              <span className="text-light">About</span>
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default NavBar;
